import { autoinject } from 'aurelia-framework';
import { DOM } from 'aurelia-pal';

@autoinject
export class RecaptchaCheckbox {
	constructor(private element: Element) { }

	// DOM element assigned before attached
	recaptchaCheckbox: Element;

	attached() {
		this.initializeRecaptcha();
	}

	initializeRecaptcha() {
		if (window.grecaptcha) {
			window.grecaptcha.render(this.recaptchaCheckbox, {
				'sitekey': '6LcPPwMpAAAAAMcW-PBeJd7hvAUY1r3mZtfhvH_e',
				// bind this to the component instance so it's not 'lost' in the callback
				'callback': this.onVerifyRecaptcha.bind(this),
				'expired-callback': this.onRecaptchaExpired.bind(this),
				'error-callback': this.onRecaptchaError.bind(this)
			});
		} else {
			console.error('grecaptcha is not defined');
		}
	}

	onVerifyRecaptcha(token: string) {
		try {
			this.dispatchVerifyCaptchaEvent('verify-captcha', token);
		}
		catch {
			this.dispatchVerifyCaptchaEvent('verify-captcha', 'Invalid Token');
		}
	}

	onRecaptchaExpired() {
		this.dispatchVerifyCaptchaEvent('captcha-expired');
	}

	onRecaptchaError() {
		this.dispatchVerifyCaptchaEvent('captcha-error');
	}

	dispatchVerifyCaptchaEvent(eventName: string, eventData?: any) {
		let verifyCaptchaEvent = DOM.createCustomEvent(eventName, { bubbles: true, cancelable: true, detail: eventData });
		this.element.dispatchEvent(verifyCaptchaEvent);
	}
}
